import React from 'react';
import PvcImage from '../../assets/images/sample_pvc.png'
import DriversLicenseImage from '../../assets/images/sample_drivers_license.png'
import NINImage from '../../assets/images/sample_nin.png'
import PassportImage from '../../assets/images/sample_passport.png'


function IdCardSample(props:any) {

    return (
        <div>
            
            {props.idCardType == 1 &&
                <div>
                    <img src={PvcImage} width="100%" />
                </div>
            }

            {props.idCardType == 2 &&
                <div>
                    <img src={PassportImage} width="100%" />
                </div>
            }

            {props.idCardType == 3 &&
                <div>
                    <img src={NINImage} width="100%" />
                </div>
            }

            {props.idCardType == 4 &&
                <div>
                    <img src={DriversLicenseImage} width="100%" />
                </div>
            }

        </div>
    );
}

export default IdCardSample;